import {
  LayoutDashboard,
  LifeBuoy,
  type LucideIcon,
  Network,
  Star,
  TrendingUp,
  Trophy,
  UserCircle,
  Wallet,
} from 'lucide-react';

export interface NavLinkItem {
  label: string;
  to: string;
}

export interface NavGroupItem {
  label: string;
  icon: LucideIcon;
  /** A group with no children renders as a single top-level link. */
  to?: string;
  items?: NavLinkItem[];
}

/**
 * User sidebar. Same structure as §7, but the Income group is the Alpha One
 * taxonomy (§8) — no ROI, no royalty, no pool screens.
 */
export const userNav: NavGroupItem[] = [
  { label: 'Dashboard', icon: LayoutDashboard, to: '/' },
  {
    label: 'Profile',
    icon: UserCircle,
    items: [
      { label: 'My Profile', to: '/profile' },
      { label: 'Security', to: '/security' },
      { label: 'My Wallet', to: '/wallet-status' },
    ],
  },
  {
    label: 'Package',
    icon: Star,
    items: [
      { label: 'Activate', to: '/activation' },
      { label: 'Activation History', to: '/activation/history' },
    ],
  },
  {
    label: 'Income',
    icon: TrendingUp,
    items: [
      { label: 'Direct Referral Bonus', to: '/income/direct-referral' },
      { label: 'Level Income', to: '/income/level-income' },
      { label: 'Alpha Club A', to: '/income/alpha-club-a' },
      { label: 'Alpha Club B', to: '/income/alpha-club-b' },
      { label: 'Elite Rank Benefits', to: '/income/elite-rank' },
      { label: 'Achievement Rewards', to: '/income/achievement-rewards' },
    ],
  },
  {
    label: 'Team',
    icon: Network,
    items: [
      { label: 'Direct Team', to: '/team/direct' },
      { label: 'Level Team', to: '/team/level' },
      { label: 'Referral List', to: '/team/referral-list' },
      { label: 'Binary Tree', to: '/team/binary' },
    ],
  },
  {
    label: 'Wallet',
    icon: Wallet,
    items: [
      { label: 'Deposit', to: '/wallet/deposit' },
      { label: 'Withdrawal', to: '/wallet/withdrawal' },
      { label: 'Transfer', to: '/wallet/transfer' },
      { label: 'Transactions', to: '/wallet/transactions' },
    ],
  },
  { label: 'Rank', icon: Trophy, to: '/rank' },
  {
    label: 'Support',
    icon: LifeBuoy,
    items: [
      { label: 'New Ticket', to: '/support/create' },
      { label: 'My Tickets', to: '/support/list' },
    ],
  },
];
